// src/redux/briefing/briefingSlice.js
import { createSlice } from '@reduxjs/toolkit';

export const briefingSlice = createSlice({
  name: 'briefing',
  initialState: {
    section: 'ops', // ops or safety
    line: 'Briefings', // Old Briefings or Briefings
  },
  reducers: {
    setBriefing: (state, action) => action.payload,
  },
});

export const { setBriefing } = briefingSlice.actions;
export default briefingSlice.reducer;
